export const avoir = {
  title: "Credit Notes",
  search_placeholder: "Search",
  all: "All",
  draft: "Drafts",
  finalized: "To be validated",
  paid: "Validated",
  to_pay: "Published",
  client_name: "Client",
  empty_title: "Create a credit note",
  empty_description: "Easily create and send your credit notes to clients",
  select_client_first: "Select a client first",
  choose_client: "Choose a client",
  create_button: "Create a credit note",
  company_name: "Company name",
  new_invoice: "New sales credit note",
  recipient: "Recipient",
  new_client: "New client",
  choose_company: "Select a company",
  new_companies: "New company",
  Informations: "Information",
  currency: "Currency (required)",
  checkboxTVA: "VAT not applicable",
  SellerName: "Supplier name",
  SellerEmail: "Supplier email",
  SellerAdress: "Supplier address",
  InvoiceNumber: "Credit note number",
  CommandNumber: "Order number",
  InvoiceDate: "Credit note date",
  DueDateInvoice: "Due date",
  TypeInvoice: "Credit note type",
  articles: "Items",
  type: "Type",
  Quantity: "Quantity",
  PriceHT: "Price excl. VAT",
  TotalHt: "Total excl. VAT",
  TVA: "VAT",
  Débours: "Disbursements",
  Reduction: "Discount %",
  AddDebours: "+ Add disbursement",
  Réglement: "Payment",
  conditions: "Payment terms",
  reglementMode: "Payment method",
  IntérétsRetard: "Late payment interest",
  new_IntérétsRetard: "No late payment interest",
  new_IntérétsRetard2: "Bank account (RIB)",
  new_conditions: "45 days end of month",
  new_reglementMode: "Bank transfer",
  client: "Client",
  clientName: "Client name",
  ClientEmail: "Client email",
  ClientAdress: "Client address",
  amount: "Amount",
  due_date: "Due date",
  status: "Status",
  submit: "Save credit note",
  DocumentText: "Text displayed on the document",
  Keywords: "Keywords",
  ChooseKeywords: "Add/Select keywords",
  Notes: "Notes",
  PaimentSolution: "Quick payment solution",
  add_line: "+ Add line",
  end_date: "To",
  start_date: "Credit note date",
  cancel: "Cancel",
  preview: "Preview",
  save_draft: "Save draft",
  finalize: "Finalize the credit note",
  created_success: "Credit note created successfully!",
  creation_failed: "Credit note creation failed",
  line_removed: "Line removed",
  line_added: "New line added",
  from: "From",
  company: "Company",
  find_invoice: "Select invoice",
  title_pdf_preview: "Provisional credit note",

  company_required: "Company is required",
  invoice_required: "Original invoice is required",
  client_required: "Client is required",
  invalid_date: "Invalid date",
  date_required: "Date is required",
  invalid_amount: "Invalid amount",
  positive_amount: "Amount must be positive",
  amount_required: "Amount is required",

  ref: "Ref",
  ref_invoice: "Invoice Ref",

  total_ht: "Subtotal",
  date: "Date",
  actions: "Actions",

  chooseClient: "Choose a client",
  chooseInvoice: "Choose an invoice",
  invoiceTotal: "Invoice total",
  note: "Note",
  creditAmount: "Credit amount",
  invoiceRequired: "Select invoice is required",

  amountRequired: "Amount is required",
  amountMax: "the max amount",
  positiveAmount: "Enter positive amount",
  valid: "Confirm",
};
